// extracted by mini-css-extract-plugin
module.exports = {"app-message":"app-message_app-message__FGvt0","success":"app-message_success__U_KH_","failure":"app-message_failure__HLg_L","show":"app-message_show__jfPSt"};